import { KYMW9009Model } from '../kymw9009.model';
import { GetOktaInfomationModel } from '../vo/get-okta-infomation.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';

/**
 * Okta情報取得コマンド
 * サーバーにOkta情報情報をリクエストし、結果を表示する。
 *
 * @export GetOktaInfomationListService
 * @class GetOktaInfomationListService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetOktaInfomationListService extends PlessJsonResponderSub<any> {
  private model: KYMW9009Model = null;
  private vo: GetOktaInfomationModel = null;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetOktaInfomationListService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      search: {
        GetOktaInfomationList: {
          condition: {
            UserNmKanji: this.vo.UserNmKanji,
            UserDeptNm: this.vo.UserDeptNm
          }
        }
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param {KYMW9009Model} model モデルクラス
   * @param {GetOktaInfomationModel} vo Okta情報一覧取得条件VO
   * @memberof GetOktaInfomationListService
   */
  execute(model: KYMW9009Model, vo: GetOktaInfomationModel) {
    this.model = model;
    this.vo = vo;
    this.send('getOktaInfomationList', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetOktaInfomationListService
   */
  success(data: any) {
    // データグリッド「Okta情報一覧」を更新
    this.model.updateOktaInfoList(data);
  }
}
